import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 6C6 7.10457 5.10457 8 4 8C2.89543 8 2 7.10457 2 6C2 4.89543 2.89543 4 4 4C5.10457 4 6 4.89543 6 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 14C6 15.1046 5.10457 16 4 16C2.89543 16 2 15.1046 2 14C2 12.8954 2.89543 12 4 12C5.10457 12 6 12.8954 6 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 6C22 7.10457 21.1046 8 20 8C18.8954 8 18 7.10457 18 6C18 4.89543 18.8954 4 20 4C21.1046 4 22 4.89543 22 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V15C22 15.1069 21.9832 15.2099 21.9522 15.3065C21.9837 15.5335 22 15.7651 22 16C22 18.7614 19.7614 21 17 21C14.2386 21 12 18.7614 12 16H3C2.44772 16 2 15.5523 2 15V5ZM4 14H12.4164C13.1878 12.2345 14.9488 11 17 11C18.126 11 19.1646 11.372 20 11.9997V6H4V14ZM17 13C15.6035 13 14.4275 13.9551 14.0945 15.2493C14.033 15.4881 14 15.7395 14 16C14 17.6569 15.3431 19 17 19C18.6569 19 20 17.6569 20 16C20 15.7395 19.967 15.4881 19.9055 15.2493C19.5725 13.9551 18.3965 13 17 13Z",
			fill: "currentColor"
		})
	]
});
export default SvgCash;
